var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.servcOrder, rules: _vm.checkServcOrder }
        },
        [
          _c("div", { staticClass: "block-container" }, [
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("合同信息")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("选择合同")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "313px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.servcOrder.contractName,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "contractName", $$v)
                        },
                        expression: "servcOrder.contractName"
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      on: { click: _vm.contractSelect }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("合同编号")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "313px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x bottom-line",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.servcOrder.contractOriginalNo,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "contractOriginalNo", $$v)
                        },
                        expression: "servcOrder.contractOriginalNo"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _vm.contractId != null &&
            _vm.trackPhaseList != null &&
            _vm.trackPhaseList.length > 0
              ? _c("div", { staticClass: "form-single mt20 mb20" }, [
                  _c("div", { staticClass: "title required" }, [
                    _vm._v("选择合同阶段")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "pos-rel",
                        staticStyle: { width: "313px" }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "fl",
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.trackPhaseId,
                              callback: function($$v) {
                                _vm.trackPhaseId = $$v
                              },
                              expression: "trackPhaseId"
                            }
                          },
                          _vm._l(_vm.trackPhaseList, function(trackPhase) {
                            return _c("el-option", {
                              key: trackPhase.id,
                              attrs: {
                                label: trackPhase.name,
                                value: trackPhase.id
                              }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content-caption dashed bg-white" }, [
              _c("span", [_vm._v("服务信息")])
            ]),
            _vm._v(" "),
            _c("table", { staticClass: "custom-tbl" }, [
              _c("thead", { staticClass: "head" }, [
                _c("tr", { staticClass: "row" }, [
                  _c(
                    "th",
                    { attrs: { width: "50" } },
                    [
                      _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            _vm.selectAll()
                          }
                        },
                        model: {
                          value: _vm.allChecked,
                          callback: function($$v) {
                            _vm.allChecked = $$v
                          },
                          expression: "allChecked"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { width: "" }
                    },
                    [_vm._v("名称")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("质保期(天)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("上门费(元)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("工时费(元)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "80" }
                    },
                    [_vm._v("服务费(元)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { width: "" }
                    },
                    [_vm._v("固定规格说明")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "120" }
                    },
                    [_vm._v("响应时长(分钟)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "120" }
                    },
                    [_vm._v("到达时长(分钟)")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { width: "120" }
                    },
                    [_vm._v("完成时长(分钟)")]
                  ),
                  _vm._v(" "),
                  _vm.contractId != null
                    ? _c(
                        "th",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { width: "70" }
                        },
                        [_vm._v("服务次数")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contractId != null
                    ? _c(
                        "th",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { width: "80" }
                        },
                        [_vm._v("已服务次数")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", { attrs: { width: "", align: "left" } }, [
                    _vm._v("操作")
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.contractId != null
                ? _c(
                    "tbody",
                    { staticClass: "body" },
                    [
                      _vm._l(_vm.servcOrder.servcOrderItemList, function(
                        servOrderItem
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c(
                            "td",
                            [
                              _c("el-checkbox", {
                                on: {
                                  change: function($event) {
                                    _vm.selectMku(servOrderItem)
                                  }
                                },
                                model: {
                                  value: servOrderItem.checked,
                                  callback: function($$v) {
                                    _vm.$set(servOrderItem, "checked", $$v)
                                  },
                                  expression: "servOrderItem.checked"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(servOrderItem.name))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.wrntPeriod))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            servOrderItem.msu.toDoorFee != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        servOrderItem.toDoorFee
                                      ).toFixed(2)
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            servOrderItem.msu.workHourFee != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        servOrderItem.msu.workHourFee
                                      ).toFixed(2)
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            servOrderItem.price != null
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(servOrderItem.price).toFixed(2)
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("0.00")])
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(servOrderItem.msu.fixedSpec))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.yqRspTimeMi || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.yqArriveTimeMi || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.yqRepairedTimeMi || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.quantity || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.usedQuantity || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", { attrs: { align: "left" } }, [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeMsu(servOrderItem.ssuId)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _c("tr", { staticClass: "row" }, [
                        _c(
                          "td",
                          {
                            staticClass: "display-none",
                            attrs: { colspan: "13" }
                          },
                          [
                            _c("div", { staticClass: "no-data" }, [
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-zanwushuju mr10",
                                staticStyle: {
                                  "font-size": "58px",
                                  "vertical-align": "middle"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {}, [_vm._v("暂无数据 . . .")])
                            ])
                          ]
                        )
                      ])
                    ],
                    2
                  )
                : _c(
                    "tbody",
                    { staticClass: "body" },
                    [
                      _vm._l(_vm.servcOrder.servcOrderItemList, function(
                        servOrderItem
                      ) {
                        return _c("tr", { staticClass: "row" }, [
                          _c(
                            "td",
                            [
                              _c("el-checkbox", {
                                attrs: { "el-checkbox": "" },
                                on: {
                                  change: function($event) {
                                    _vm.selectMku(servOrderItem)
                                  }
                                },
                                model: {
                                  value: servOrderItem.checked,
                                  callback: function($$v) {
                                    _vm.$set(servOrderItem, "checked", $$v)
                                  },
                                  expression: "servOrderItem.checked"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(servOrderItem.title))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.wrntPeriod))
                          ]),
                          _vm._v(" "),
                          servOrderItem.toDoorFee != null
                            ? _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        servOrderItem.toDoorFee
                                      ).toFixed(2)
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          servOrderItem.workHourFee != null
                            ? _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        servOrderItem.workHourFee
                                      ).toFixed(2)
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          servOrderItem.generallFee != null
                            ? _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        servOrderItem.generallFee
                                      ).toFixed(2)
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "left" } }, [
                            _vm._v(_vm._s(servOrderItem.fixedSpec))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.yqRspTimeMi || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.yqArriveTimeMi || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(_vm._s(servOrderItem.yqRepairedTimeMi || 0))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                staticClass: "swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeMsu(servOrderItem.ssuId)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _c("tr", { staticClass: "row" }, [
                        _c(
                          "td",
                          {
                            staticClass: "display-none",
                            attrs: { colspan: "11" }
                          },
                          [
                            _c("div", { staticClass: "no-data" }, [
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-zanwushuju mr10",
                                staticStyle: {
                                  "font-size": "58px",
                                  "vertical-align": "middle"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {}, [_vm._v("暂无数据 . . .")])
                            ])
                          ]
                        )
                      ])
                    ],
                    2
                  ),
              _vm._v(" "),
              _c("tfoot", { staticClass: "foot" }, [
                _vm.contractId == null
                  ? _c("tr", { staticClass: "row" }, [
                      _c("td", { attrs: { colspan: "11" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "swb-btn-link",
                            class: {
                              "swb-btn-disabled": _vm.isShow,
                              "pointer-events: none": _vm.isShow
                            },
                            style: { "pointer-events: none": _vm.isShow },
                            on: { click: _vm.addServ }
                          },
                          [
                            _c("span", [
                              _c("i", {
                                staticClass: "icon iconfont icon-jiahao mr5"
                              }),
                              _vm._v(
                                "选择服务\n                                "
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single" }, [
              _c("div", { staticClass: "title required" }, [
                _vm._v("选择零售商")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  {
                    staticClass: "pos-rel mb15",
                    staticStyle: { width: "313px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "peerMerchantName" } },
                      [
                        _c("el-input", {
                          staticClass: "width-2x bottom-line",
                          attrs: { disabled: true },
                          model: {
                            value: _vm.servcOrder.peerMerchantName,
                            callback: function($$v) {
                              _vm.$set(_vm.servcOrder, "peerMerchantName", $$v)
                            },
                            expression: "servcOrder.peerMerchantName"
                          }
                        }),
                        _vm._v(" "),
                        _vm.contractId == null
                          ? _c("i", {
                              staticClass:
                                "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                              on: { click: _vm.selectRetail }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [
                _vm._v("零售商机构")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "313px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "buyerShopName" } },
                      [
                        _c("el-input", {
                          staticClass: "width-2x bottom-line",
                          attrs: { disabled: true },
                          model: {
                            value: _vm.servcOrder.buyerShopName,
                            callback: function($$v) {
                              _vm.$set(_vm.servcOrder, "buyerShopName", $$v)
                            },
                            expression: "servcOrder.buyerShopName"
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                          on: { click: _vm.selectRetailOrg }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("机构联系人")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "313px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      model: {
                        value: _vm.servcOrder.buyerShopContactName,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "buyerShopContactName", $$v)
                        },
                        expression: "servcOrder.buyerShopContactName"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("机构电话")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "313px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-2x",
                      model: {
                        value: _vm.servcOrder.buyerShopContactTel,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "buyerShopContactTel", $$v)
                        },
                        expression: "servcOrder.buyerShopContactTel"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("预约时间")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      placeholder: "选择日期",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.planTime,
                      callback: function($$v) {
                        _vm.planTime = $$v
                      },
                      expression: "planTime"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.contractId == null
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-single mt20 mb20" },
                    [
                      _c("div", { staticClass: "title required" }, [
                        _vm._v("是否开发票")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.invoiceClaimed,
                            callback: function($$v) {
                              _vm.invoiceClaimed = $$v
                            },
                            expression: "invoiceClaimed"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.invoiceClaimed == true
                    ? _c("div", [
                        _c("div", { staticClass: "form-single mt20 mb20" }, [
                          _c("div", { staticClass: "title required" }, [
                            _vm._v("发票类型")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _c(
                              "ul",
                              { staticClass: "enum-list" },
                              _vm._l(_vm.invoiceTypeList, function(
                                invoiceType,
                                index
                              ) {
                                return _c(
                                  "li",
                                  {
                                    staticClass: "enum-item",
                                    class: {
                                      checked:
                                        _vm.servcOrder.invoiceType ==
                                        invoiceType.value
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.changInvoiceTypeType(
                                          invoiceType,
                                          index
                                        )
                                      }
                                    },
                                    model: {
                                      value: invoiceType.value,
                                      callback: function($$v) {
                                        _vm.$set(invoiceType, "value", $$v)
                                      },
                                      expression: " invoiceType.value"
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(invoiceType.name))
                                    ]),
                                    _vm._v(" "),
                                    _c("i")
                                  ]
                                )
                              })
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-single mt20 mb20" }, [
                          _c("div", { staticClass: "title required" }, [
                            _vm._v("发票内容标签")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _c(
                              "ul",
                              { staticClass: "enum-list" },
                              _vm._l(_vm.invoiceContentTagList, function(
                                invoiceContentTag,
                                index
                              ) {
                                return _c(
                                  "li",
                                  {
                                    staticClass: "enum-item",
                                    class: {
                                      checked:
                                        _vm.servcOrder.invoiceContentTag ==
                                        invoiceContentTag.name
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.changInvoiceContentTag(
                                          invoiceContentTag,
                                          index
                                        )
                                      }
                                    },
                                    model: {
                                      value: invoiceContentTag.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          invoiceContentTag,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: " invoiceContentTag.value"
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(invoiceContentTag.name))
                                    ]),
                                    _vm._v(" "),
                                    _c("i")
                                  ]
                                )
                              })
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-single mt20 mb20" }, [
                          _c("div", { staticClass: "title required" }, [
                            _vm._v("发票抬头")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "pos-rel",
                                staticStyle: { width: "313px" }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "width-2x bottom-line",
                                  model: {
                                    value: _vm.servcOrder.invoiceTitle,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.servcOrder,
                                        "invoiceTitle",
                                        $$v
                                      )
                                    },
                                    expression: "servcOrder.invoiceTitle"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-single mt20 mb20" }, [
                          _c("div", { staticClass: "title required" }, [
                            _vm._v("纳税人识别号")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _c(
                              "div",
                              {
                                staticClass: "pos-rel",
                                staticStyle: { width: "313px" }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "width-2x bottom-line",
                                  model: {
                                    value: _vm.servcOrder.taxPayerNo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.servcOrder,
                                        "taxPayerNo",
                                        $$v
                                      )
                                    },
                                    expression: "servcOrder.taxPayerNo"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content-caption dashed bg-white" },
                    [_c("span", [_vm._v("支付信息")])]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-single mt20 mb20" }, [
                    _c("div", { staticClass: "title required" }, [
                      _vm._v("付款时机")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c(
                        "ul",
                        { staticClass: "enum-list" },
                        _vm._l(_vm.payTimingList, function(payTiming, index) {
                          return _c(
                            "li",
                            {
                              staticClass: "enum-item",
                              class: {
                                checked:
                                  _vm.servcOrder.payTiming == payTiming.value
                              },
                              on: {
                                click: function($event) {
                                  _vm.changPayTiming(payTiming, index)
                                }
                              },
                              model: {
                                value: _vm.servcOrder.payTiming,
                                callback: function($$v) {
                                  _vm.$set(_vm.servcOrder, "payTiming", $$v)
                                },
                                expression: "servcOrder.payTiming"
                              }
                            },
                            [
                              _c("span", [_vm._v(_vm._s(payTiming.name))]),
                              _vm._v(" "),
                              _c("i")
                            ]
                          )
                        })
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-single" }, [
                    _c("div", { staticClass: "title required" }, [
                      _vm._v("支付方式")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c(
                        "ul",
                        { staticClass: "enum-list" },
                        _vm._l(_vm.payWayList, function(payWay, index) {
                          return _c(
                            "li",
                            {
                              staticClass: "enum-item",
                              class: {
                                checked: _vm.servcOrder.payWay == payWay.value
                              },
                              on: {
                                click: function($event) {
                                  _vm.changPayWay(payWay, index)
                                }
                              },
                              model: {
                                value: _vm.servcOrder.payWay,
                                callback: function($$v) {
                                  _vm.$set(_vm.servcOrder, "payWay", $$v)
                                },
                                expression: "servcOrder.payWay"
                              }
                            },
                            [
                              _c("span", [_vm._v(_vm._s(payWay.name))]),
                              _vm._v(" "),
                              _c("i")
                            ]
                          )
                        })
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("故障描述")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "600px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "故障描述最大长度120个字",
                        maxlength: 120
                      },
                      model: {
                        value: _vm.servcOrder.troubleDesc,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "troubleDesc", $$v)
                        },
                        expression: "servcOrder.troubleDesc"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title" }, [_vm._v("附言")]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "600px" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "附言最大长度120个字",
                        maxlength: 120
                      },
                      model: {
                        value: _vm.servcOrder.postscript,
                        callback: function($$v) {
                          _vm.$set(_vm.servcOrder, "postscript", $$v)
                        },
                        expression: "servcOrder.postscript"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-single mt20 mb20" }, [
              _c("div", { staticClass: "title required" }, [
                _vm._v("预计交易总金额")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "pos-rel", staticStyle: { width: "313px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "totalAmount" } },
                      [
                        _c("el-input", {
                          staticClass: "width-2x bottom-line",
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.servcOrder.totalAmount,
                            callback: function($$v) {
                              _vm.$set(_vm.servcOrder, "totalAmount", $$v)
                            },
                            expression: "servcOrder.totalAmount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: { click: _vm.submitClick }
          },
          [_vm._v("提交")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-757a89c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-757a89c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcOrder/ServcOrderCreate.vue
// module id = 2040
// module chunks = 1